import { createFileRoute } from "@tanstack/react-router"
import { InvoiceDetailPage } from "@/pages"
import { AuthorizationGate } from "@/components"
import { Resource, Action } from "@mimber/schema"

export const Route = createFileRoute(
  "/_authenticated/_organization/finance/invoices/$invoiceUuid/"
)({
  component: () => (
    <AuthorizationGate resource={Resource.INVOICE} action={Action.READ}>
      <InvoiceDetailPage />
    </AuthorizationGate>
  ),
})
